import React from "react";
import { SAKPreview } from "./SAKPreview";
import styles from "./SAKPreviewContainer.module.css";

interface SAKPreviewProps {
  status: string;
  uploadedPhotoUrl: string;
  surveyCompleted?: boolean;
}

const SAKPreviewContainer: React.FC<SAKPreviewProps> = ({
  status,
  uploadedPhotoUrl,
  surveyCompleted = false
}) => {
  // Determine content based on status.
  let content: React.ReactNode;

  // These are listed in the order in which they occour in the flow.
  switch (status) {
    case "photo-pending":
    case "photo-loading":
      return null;
    case "photo-review":
      content = <SAKPreview status={status} imageUrl={uploadedPhotoUrl} />;
      break;
    case "photo-rejected":
      content = <SAKPreview status={status} />;
      break;
    case "questionnaire":
      content = <SAKPreview status={status} imageUrl={uploadedPhotoUrl} />;
      break;
    case "post-order-flow-completed":
      content = (
        <SAKPreview status={status} imageUrl={uploadedPhotoUrl} surveyCompleted={surveyCompleted} />
      );
      break;
    case "photo-skipped":
    default:
      return null;
  }

  return <div className={styles.preview}>{content}</div>;
};

export default SAKPreviewContainer;
